export default {
  contactTitle: "CONTACT_TITLE"
}


// WEBPACK FOOTER //
// ./src/locales/contact/index.ts